import { RemoteInvoice } from "../../../../data/usecases/invoice/remote-invoice";
import { Invoice } from "../../../../domain/models/invoice";
import { settings } from "../../../configs/settings";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteInvoice = (): Invoice =>
  new RemoteInvoice("/invoices", makeAxiosHttpClient(), settings.API_URL);